import React, { useState, useEffect, useRef } from 'react'
import { injectIntl } from 'react-intl'
import { SearchOutlined } from '@ant-design/icons'
import { Input } from 'antd'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom/cjs/react-router-dom.min'
import style from './style.module.scss'

const mapStateToProps = ({ menu }) => ({
  menuData: menu.menuData,
})

let searchInput = null

const Search = ({ menuData }) => {
  const [showSearch, setShowSearch] = useState(false)
  const [searchText, setSearchText] = useState('')
  const [menuSearch, setMenuSearch] = useState([])
  const [menuResult, setMenuResult] = useState([])
  const containerRef = useRef(null)

  useEffect(() => {
    document.addEventListener('keydown', handleKeyDown, false)
    document.addEventListener('mousedown', handleClickOutside, false)
    return () => {
      document.removeEventListener('keydown', handleKeyDown)
      document.removeEventListener('mousedown', handleClickOutside)
    }
  })

  useEffect(() => {
    const transformData = (data) => {
      const result = []

      const flatten = (item) => {
        if (item?.url) {
          result.push({
            id: item.id,
            title: item.title,
            key: item.key,
            url: item.url,
          })
        }
        if (item.children) {
          item.children.forEach(flatten)
        }
      }

      data.forEach(flatten)
      return result
    }
    const resultTranformacion = menuData !== null ? transformData(menuData) : []
    setMenuSearch(resultTranformacion)
  }, [menuData])

  const showLiveSearch = () => {
    setShowSearch(true)
    setTimeout(() => {
      searchInput.focus()
    }, 100)
  }

  const changeSearchText = (e) => {
    setSearchText(e.target.value)
    // Función para normalizar texto eliminando tildes, apóstrofes y otros signos
    const normalize = (str) =>
      str
        .normalize('NFD')
        .replace(/[\u0300-\u036f']/g, '') // elimina tildes y apóstrofes
        .toLowerCase()

    const searchValue = normalize(e.target.value)
    const busqueda = menuSearch?.filter((item) => normalize(item.title).includes(searchValue))
    const busquedaOrdenada = busqueda.sort((a, b) => {
      if (a.title > b.title) {
        return 1
      }
      if (a.title < b.title) {
        return -1
      }
      // a must be equal to b
      return 0
    })
    setMenuResult(busquedaOrdenada)
  }

  const hideLiveSearch = () => {
    searchInput.blur()
    setShowSearch(false)
    setSearchText('')
  }

  const handleKeyDown = (event) => {
    if (showSearch) {
      const key = event.keyCode.toString()
      if (key === '27') {
        hideLiveSearch()
      }
    }
  }

  // En escritorio el panel ya no cubre la pantalla, así que hace falta cerrarlo al pinchar fuera.
  const handleClickOutside = (event) => {
    if (showSearch && containerRef.current && !containerRef.current.contains(event.target)) {
      hideLiveSearch()
    }
  }

  const handleNode = (node) => {
    searchInput = node
  }

  const MostrarResultadosBusqueda = () => {
    return (
      <div className={style.results}>
        <div className={style.resultsTitle}>
          <span>Resultados de búsqueda</span>
        </div>
        <div className="row">
          {menuResult.map((item, index) => (
            <div key={item.id} className="col-12">
              <div className={style.resultContent}>
                <div className={style.resultThumb}>{(index + 1).toString().padStart(2, '0')}</div>
                <Link to={item.url} target="_blank">
                  <div className={style.result}>
                    <div className={style.resultText}>{item.title}</div>
                    <div className={style.resultSource}> </div>
                  </div>
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    )
  }

  return (
    <div className={`d-inline-block mr-4 ${style.searchContainer}`} ref={containerRef}>
      <Input
        className={style.extInput}
        placeholder="Búsqueda de páginas"
        prefix={<SearchOutlined style={{ color: 'rgba(0,0,0,.25)' }} />}
        style={{ width: 200 }}
        onFocus={showLiveSearch}
      />
      <div
        className={`${
          showSearch ? `${style.livesearch} ${style.livesearchVisible}` : style.livesearch
        }`}
        id="livesearch"
      >
        <button className={style.close} type="button" onClick={hideLiveSearch}>
          <i className="icmn-cross" />
        </button>
        <div className="container-fluid">
          <div className={style.wrapper}>
            <input
              type="search"
              autoComplete="off"
              className={style.searchInput}
              value={searchText}
              onChange={changeSearchText}
              id="livesearchInput"
              placeholder="introduzca el texto a buscar....."
              ref={handleNode}
            />
            {!searchText && (
              <div className={style.results}>
                <div className={style.resultsTitle}>
                  <span>Sin resultados encontrados</span>
                </div>
              </div>
            )}
            {searchText && <MostrarResultadosBusqueda />}
          </div>
        </div>
      </div>
    </div>
  )
}

export default connect(mapStateToProps, null)(injectIntl(Search))
